export default () => ({
    defaultProps: {
        size: "small",
    },
});
